import React from 'react';
import { Section } from './ui/Section';
import { AlertTriangle, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section background="alt" className="border-t border-[#E5E0D6]" data-id="element-116">
      <div className="max-w-3xl mx-auto" data-id="element-117">
        {/* The Emotional Hook */}
        <div className="mb-16" data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-8 font-serif" data-id="element-119">
            Hay un tipo de miedo que casi nadie dice en voz alta.
          </h2>

          <div className="space-y-6 text-lg text-[#4A4A4A] leading-relaxed" data-id="element-120">
            <p data-id="element-121">No es "me duele la rodilla".</p>
            <p className="font-semibold text-[#1A5F5A] text-xl bg-white/50 p-4 rounded-lg border-l-4 border-[#1A5F5A]" data-id="element-122">
              Es este: "¿Y si me falla justo cuando estoy afuera?"
            </p>
            <p data-id="element-123">
              Y entonces pasa lo mismo: empiezas a medir distancias, a buscar
              dónde sentarte, a caminar más lento… y a salir menos.
            </p>
          </div>
        </div>

        {/* The Failed Solutions */}
        <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-[#E5E0D6]" data-id="element-124">
          <h3 className="text-2xl font-bold text-[#2D2D2D] mb-8 text-center font-serif" data-id="element-125">
            La mayoría prueba una de estas dos rutas <br data-id="element-126" />
            <span className="text-[#C96B4B] text-lg font-sans font-normal" data-id="element-127">
              (y por eso se quedan igual)
            </span>
          </h3>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-128">
            <div className="bg-[#FDFBF7] p-6 rounded-xl border border-red-100" data-id="element-129">
              <div className="flex items-center mb-4 text-red-800 font-bold" data-id="element-130">
                <XCircle className="w-6 h-6 mr-2 text-red-500" data-id="element-131" />
                Ruta #1: "Mejor descanso"
              </div>
              <p className="text-[#4A4A4A]" data-id="element-132">
                Descansas… baja un poco la molestia… pero en días o semanas te
                sientes más débil. Y la debilidad se siente como "me va a
                fallar".
              </p>
            </div>

            <div className="bg-[#FDFBF7] p-6 rounded-xl border border-red-100" data-id="element-133">
              <div className="flex items-center mb-4 text-red-800 font-bold" data-id="element-134">
                <XCircle className="w-6 h-6 mr-2 text-red-500" data-id="element-135" />
                Ruta #2: Ejercicios de internet
              </div>
              <p className="text-[#4A4A4A]" data-id="element-136">
                Te salen rutinas de impacto, rodillas al piso, saltos, o
                movimientos que no están pensados para un día sensible. Un mal
                intento y dices "esto no es para mí".
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}